/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class NextgenReportSettings {
    getFixupPrototypeFunction() { return NextgenReportSettings.fixupPrototype; }

    static newInstance(model: Partial<NextgenReportSettings>): NextgenReportSettings {
        let obj = Object.assign(new NextgenReportSettings(), model);
        NextgenReportSettings.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<NextgenReportSettings>): NextgenReportSettings {
        if (!model) return null;
        return NextgenReportSettings.newInstance(<NextgenReportSettings> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: NextgenReportSettings) {
        if (!obj) return;

        models.NextgenReportSettings.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: NextgenReportSettings): boolean {
        Object.setPrototypeOf(obj, NextgenReportSettings.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.max_allowed_groupby_count === undefined) {
            this.max_allowed_groupby_count = 0;
        }
    }

    /**
     * Maximum number of group by fields allowed in a report
     */
    max_allowed_groupby_count: number;

}
